import BoldToolbarView from "./BoldToolbarView.vue";
import {Bold as BoldExtension} from "@tiptap/extension-bold";

export default class Bold {

    constructor() {
        this.toolbarView = BoldToolbarView;
    }

    static create() {
        return new Bold();
    }

    getExtensions() {
        return [BoldExtension];
    }
}